import React, { useEffect, useRef } from 'react'
import './Hero.css'
import MainVideo from './images/video.mp4'
import { Link } from 'react-scroll'
import { BiPhoneCall } from 'react-icons/bi'

const Hero = () => {
  const canvasRef = useRef(null)

  /* ── Particle network canvas ── */
  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    let animId
    let particles = []

    const resize = () => {
      canvas.width  = canvas.offsetWidth
      canvas.height = canvas.offsetHeight
    }
    resize()
    window.addEventListener('resize', resize)

    const N = Math.min(60, Math.floor((canvas.width * canvas.height) / 16000))

    for (let i = 0; i < N; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.4,
        vy: (Math.random() - 0.5) * 0.4,
        r: Math.random() * 1.8 + 0.6,
      })
    }

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      particles.forEach(p => {
        p.x += p.vx
        p.y += p.vy
        if (p.x < 0) p.x = canvas.width
        if (p.x > canvas.width) p.x = 0
        if (p.y < 0) p.y = canvas.height
        if (p.y > canvas.height) p.y = 0

        ctx.beginPath()
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2)
        ctx.fillStyle = 'rgba(0, 164, 255, 0.55)'
        ctx.fill()
      })

      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x
          const dy = particles[i].y - particles[j].y
          const dist = Math.sqrt(dx * dx + dy * dy)
          if (dist < 120) {
            ctx.beginPath()
            ctx.moveTo(particles[i].x, particles[i].y)
            ctx.lineTo(particles[j].x, particles[j].y)
            ctx.strokeStyle = `rgba(0, 164, 255, ${0.18 * (1 - dist / 120)})`
            ctx.lineWidth = 0.8
            ctx.stroke()
          }
        }
      }
      animId = requestAnimationFrame(draw)
    }
    draw()

    return () => {
      cancelAnimationFrame(animId)
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <section name='Hero' className='hero' aria-label="Hero section">
      {/* Background video */}
      <video className="hero__video" autoPlay loop muted playsInline aria-hidden="true">
        <source src={MainVideo} type='video/mp4' />
      </video>

      {/* Dark gradient overlay */}
      <div className="hero__overlay" aria-hidden="true" />

      {/* Particle canvas */}
      <canvas ref={canvasRef} className="hero__canvas" aria-hidden="true" />

      {/* Content */}
      <div className="hero__content">
        <p className="hero__label hero__anim hero__anim--1">
          <BiPhoneCall size={16} style={{ verticalAlign: 'middle', marginRight: '6px' }} />
          Call us &mdash; <a href="tel:+918652816746" className="hero__phone">+91&nbsp;8652816746</a>
        </p>

        <h1 className="hero__headline hero__anim hero__anim--2">
          The Only Connection<br />
          <span className="hero__headline-accent">You Need</span>
        </h1>

        <p className="hero__sub hero__anim hero__anim--3">
          Once You've Tried It, You're Never Stopping Again
        </p>

        <div className="hero__badges hero__anim hero__anim--4">
          <span className="hero__badge">Lightning Fast</span>
          <span className="hero__badge">Unlimited Data</span>
          <span className="hero__badge">Fiber Optic</span>
        </div>

        <div className="hero__cta hero__anim hero__anim--5">
          <Link to="Plan" smooth duration={500} offset={-30}>
            <button className="btn-primary hero__btn">
              View Our Plans
            </button>
          </Link>
          <a href="tel:+918652816746" className="hero__cta-link">
            <BiPhoneCall size={18} /> Contact Us
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hero__scroll-hint" aria-hidden="true">
        <span />
      </div>
    </section>
  )
}

export default Hero
